<div class="dialog-title">
  <mat-icon class="close-icon" (click)="close()">close</mat-icon>
</div>

<loading></loading>

<mat-dialog-content>

  <newsletter class="newsletter-popup" mode="popup" (emailAdded)="close()" [content]="newsletterContent"></newsletter>

</mat-dialog-content>



